import { render, staticRenderFns } from "./financial-services.vue?vue&type=template&id=1ff2b024&"
import script from "./financial-services.vue?vue&type=script&lang=js&"
export * from "./financial-services.vue?vue&type=script&lang=js&"
import style0 from "./financial-services.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports